import {iconObject} from './IconObject';

interface IProps {
  icon: string;
}

const Icon = ({icon}: IProps): JSX.Element => iconObject[icon] || <>No icon found.</>;

export default Icon;
